import { ContractPageContent } from '../../ContractsPageContent';
import { usePagination } from 'src/shared/hooks/usePagination';
import { defaultTableRowsPerPageOptions } from 'src/shared/constants/table';
import { useGetFlexflowInvitedContractsQuery } from 'src/shared/api/flexflow';
import { useFilters } from '../../FlexflowContractListActions/hooks';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import { ShowError } from 'src/shared/components/ShowError';
import Grid2 from '@mui/material/Unstable_Grid2';
import { FlexflowContractsListActions } from '../../FlexflowContractListActions';
import { FlexflowContractsTab } from '../../Contracts';
import { Box } from '@mui/material';
import Subtitle from '../../Subtitle';

export const Tab1 = () => {
  const { setFilterValues, filterScheme, filterValues } = useFilters(FlexflowContractsTab.BEFORE_ACTIVATION);
  const { handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = usePagination(
    defaultTableRowsPerPageOptions[1]
  );

  const { data, isLoading, isError, error } = useGetFlexflowInvitedContractsQuery({
    pagination: { page: page + 1, perPage: rowsPerPage },
    filterValues
  });

  if (isLoading) {
    return <ShowLoading />;
  }

  if (isError || !data) {
    return <ShowError error={error} />;
  }

  return (
    <>
      <Grid2 container xs={12} justifyContent="space-between" mb={2}>
        <Box mb={4}>
          <Subtitle descriptionI18Key="only employees with active or leave status who meet the salary requirements for access to Flexflow are shown" />
        </Box>
        <FlexflowContractsListActions
          filterValues={filterValues}
          filterScheme={filterScheme}
          setFilterValues={setFilterValues}
          handleChangePage={handleChangePage}
          data={data}
          resetFilters={() => {}}
        />
      </Grid2>
      <ContractPageContent
        isRequestedAndActiveTab={false}
        data={data}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};
